import { render, staticRenderFns } from "./FixedSumRowDesktop.vue?vue&type=template&id=78794db3"
import script from "./FixedSumRowDesktop.vue?vue&type=script&lang=js"
export * from "./FixedSumRowDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports